import { translate } from "@/config/translator";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { Dispatch, SetStateAction } from "react";
import { PspTextArea } from "@/components/pspTextArea/pspTextArea";
import { useAttendanceNoteDialog } from "./attendanceNoteDialog/useAttendanceNoteDialog";

type AttendanceNoteDialogProps = {
  name: string;
  note: string;
  setNote: Dispatch<SetStateAction<string>>;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
};

export function AttendanceNoteDialog({
  name,
  note,
  setNote,
  open,
  onClose,
  onSave,
}: AttendanceNoteDialogProps) {
  const { lang } = useAttendanceNoteDialog();

  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {translate("addNoteForName", lang, { "{name}": name })}
          </DialogTitle>
          <DialogContent>
            <PspTextArea
              rows={8}
              value={note}
              onChange={setNote}
              label="note"
            />
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              {translate("cancel", lang)}
            </Button>
            <Button onClick={onSave} appearance="primary">
              {translate("save", lang)}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
